import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {useTranslation, withTranslation} from 'react-i18next';
import {getCustomMetricsEnabledState} from "../../utils/FeatureFlags";
import {useUiVersion} from "../../context/UserModulesContext";


class PersonalizationSubTabsComponent extends Component {

    renderMetricsTab(t) {
        const flag = getCustomMetricsEnabledState();
        const disabled = flag === false;

        if (disabled) {
            return (
                <li key="metrics">
                    <span className="tab-button -disabled" title={t('personalization.tabs.metrics_coming_soon', 'Disponible próximamente')}>
                        {t('personalization.tabs.metrics', 'Métricas personalizadas')}
                    </span>
                </li>
            );
        }

        return (
            <li key="metrics">
                <Link className="tab-button" to="/agency/personalization/metrics">
                    {t('personalization.tabs.metrics', 'Métricas personalizadas')}
                </Link>
            </li>
        );
    }

    renderColumnsTab(t) {
        return (
            <li key="columns">
                <Link className="tab-button" to="/agency/personalization/columns">
                    {t('personalization.tabs.comparative_metrics', 'Métricas comparativas')}
                </Link>
            </li>
        );
    }

    render() {
        const {t, activeSubTab} = this.props;
        const activeClass = activeSubTab === 'metrics' ? '-first' : '-second';

        return (
            <div className="filters">
                <ul className={'tabs ' + activeClass}>
                    {this.renderMetricsTab(t)}
                    {this.renderColumnsTab(t)}
                </ul>
            </div>
        );
    }
}

const PersonalizationSubTabsClassic = withTranslation()(PersonalizationSubTabsComponent);

/**
 * En la 2.1 (tanda «Agencia 2.1», D3) las dos sub-solapas de Personalización son el segmentado
 * compartido, como las de Conexiones. El clásico sigue con sus pestañas de hoy.
 */
export function PersonalizationSubTabs(props) {
    const {isV2} = useUiVersion();
    if (isV2) return <PersonalizationSegmented activeSubTab={props.activeSubTab}/>;
    return <PersonalizationSubTabsClassic {...props}/>;
}

function PersonalizationSegmented({activeSubTab}) {
    const {t} = useTranslation();
    // Las métricas personalizadas pueden estar apagadas por el flag de la agencia: la opción se ve,
    // deshabilitada y con el mismo aviso que en el clásico.
    const metricsDisabled = getCustomMetricsEnabledState() === false;
    const metricsActive = activeSubTab === 'metrics';
    const columnsActive = !metricsActive;
    const metricsLabel = t('personalization.tabs.metrics', 'Métricas personalizadas');

    return (
        <div className="agv2-subnav">
            {/* El grupo se nombra como la sección, no como su primera opción (review C-05). */}
            <nav className="uiseg" aria-label={t('agency_tabs.metric_personalization')}>
                {metricsDisabled ? (
                    <span className="uiseg__btn" aria-disabled="true"
                          title={t('personalization.tabs.metrics_coming_soon', 'Disponible próximamente')}>
                        {metricsLabel}
                    </span>
                ) : (
                    <Link className={'uiseg__btn' + (metricsActive ? ' -active' : '')}
                          to="/agency/personalization/metrics" aria-current={metricsActive ? 'page' : undefined}>
                        {metricsLabel}
                    </Link>
                )}
                <Link className={'uiseg__btn' + (columnsActive ? ' -active' : '')}
                      to="/agency/personalization/columns" aria-current={columnsActive ? 'page' : undefined}>
                    {t('personalization.tabs.comparative_metrics', 'Métricas comparativas')}
                </Link>
            </nav>
        </div>
    );
}
